




































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Emit, Watch } from "vue-property-decorator";
// import StatusPasien from "../utility/StatusPasien";
// import CardDataSosial from "../components/CardDataSosial.vue";
import ComponentTanggal from "@/components/Tanggal.vue";
import CardModalGantiDokter from "@/components/modal/CardModalGantiDokter.vue";
import ModalAlert from "@/components/modal/ModalAlert.vue";
import { userModule } from "@/store/modules/user";
// import DataObject from "@/utility/DataObject";
import { storeDokter } from "@/store/modules/dokter";
import { last } from "lodash";
import HeartFailureIndicator from "@/components/icons/HeartFailureIndicator.vue";
import PasienCustomWarningIndicator from "@/components/icons/PasienCustomWarningIndicator.vue";
import PasienMultiWarningIndicator from "@/components/icons/PasienMultiWarningIndicator.vue";
import IgdTimelineCell from "@/pages/DaftarPasienIGDPage/IgdTimelineCell.vue";
import IgdStatusChip from "@/pages/DaftarPasienIGDPage/IgdStatusChip.vue";
import {
  IGD_DEFAULT_STATUS_FILTER,
  IGD_STATUS_FILTER_ALL,
  IGD_STATUS_FILTER_OPTIONS,
  isIgdStatusFilterValue
} from "@/constants/igdStatus";
// import { appModule } from "@/store/modules/app";
import PasienNewSvc from "@/services/PasienNew";
import PanggilanPoliSvc from "@/services/panggilan/PanggilanPoli";
import VisitPasienSvc from "@/services/VisitPasien";
// import DataPasien from "@/services/DataPasien";
import DataKonsul from "@/services/DataKonsul";
import storeListPasienRalan from "@/store/modules/new/ListPasienRalan";
import { actingUnitQueryForListRow } from "@/utils/actingUnit";
import moment from "moment";
import { pusher } from "@/services/PusherClient";
import { appModule } from "@/store/modules/app";
import { storeKonsul } from "@/store/modules/konsul";
import HistoryPeserta from "@/services/bridgingVclaim/HistoryPeserta";
import PasienNote from "@/services/new/PasienNote";
import ReferensiUnit from "@/store/modules/new/ReferensiUnit";
import PasienNew from "@/services/PasienNew";
import { storePasien } from "@/store/modules/pasien";
import { isDaftarPasienTanpaFilterDokter } from "@/utils/unit";
import { getUserPreferenceData } from "@/utility/ReferenceDataHelper";
// import axios from "axios";
// import { confirmRemove } from "@/utility/CommonHelper";

@Component({
  components: {
    ComponentTanggal,
    CardModalGantiDokter,
    ModalAlert,
    HeartFailureIndicator,
    PasienCustomWarningIndicator,
    PasienMultiWarningIndicator,
    IgdTimelineCell,
    IgdStatusChip
  }
})
export default class CardListPasien extends Vue {
  @Prop() readonly itemsStatus!: Array<object>;
  @Prop() itemsDokter: Array<object>;
  @Prop() readonly pasien!: Array<any>;
  @Prop() readonly poli!: any;
  @Prop() errListPx!: string;
  @Prop() loadingRm = "";
  @Prop({ default: "350" }) readonly height: string;

  status = "warning";

  date = moment().format("YYYY-MM-DD");
  sts = "-1";
  statusFilterAllValue = IGD_STATUS_FILTER_ALL;
  data = {};
  modalChangeDokterOpen = false;
  alertOpen = false;
  modalTtitle = "Ganti Dokter";
  dtDokter = {
    id: "",
    nama: ""
  };
  dtReg: object = {};
  page = "tab-soap";
  err: object = {};
  sess_login = this.stateuser;
  dokter = [];
  selectDokter = "0";

  rmCalled = null;
  disableCallBtn = false;
  pasienSetStatusVisit = null;

  pemeriksaanDebounceTimer: any = null;

  searchRm = "";
  highlightedRow = null;

  showPasienRowContext = false;
  xOfPasienRowContext = 0;
  yOfPasienRowContext = 0;
  activePasienContext = null;

  sortListByPanggilan = false;

  unitSwitchActiveId = null;

  igdAdmNotifiedAt: Record<string, number> = {};

  get activePasienContextRm() {
    return this.activePasienContext?.rm;
  }

  setPasienContext(e, item) {
    this.activePasienContext = item;

    e.preventDefault();
    this.showPasienRowContext = false;
    this.xOfPasienRowContext = e.clientX;
    this.yOfPasienRowContext = e.clientY + 10;

    this.$nextTick(() => {
      this.showPasienRowContext = true;
    });
  }

  get cardHeight() {
    return "auto";
  }

  get canJawabKonsul() {
    return (
      this.stateuser.profesi === "Dokter" ||
      this.stateuser.profesi === "Psikolog"
    );
  }

  get loadingList() {
    return storeListPasienRalan._loading;
  }

  get screen() {
    // if (this.$vuetify.breakpoint.lgAndDown) return "non";
    // else return "default";
    return "non";
  }

  get headers() {
    const headers = [
      {
        text: "No.",
        value: "queue",
        align: "left",
        width: "1vh"
      },
      { text: "RM | Identitas", value: "rm", align: "left", width: "30vh" },
      {
        text: "Kehadiran",
        value: "status_visit",
        align: "center",
        width: "10%"
      }
    ];

    if (this.sess_login.unit_id == "01") {
      headers.push({
        text: "Waktu & LOS (KEMENKES)",
        value: "igd_timeline",
        align: "left",
        width: "180px"
      });
      headers.push({
        text: "Status IGD",
        value: "igd_status",
        align: "center",
        width: "150px"
      });
    }

    if (this.showPanggilan) {
      headers.push({
        text: "Panggilan",
        value: "nama",
        align: "center",
        width: "10%"
      });
    }

    if (this.canFilterByDokter) {
      headers.push({
        text: "Dokter",
        value: "dokter",
        align: "center",
        width: "20vh"
      });
    }

    headers.push(
      {
        text: "Status Periksa",
        value: "resume",
        align: "center",
        width: "10%"
      },
      {
        text: "Soap",
        value: "soap",
        align: "center",
        width: "10%"
      },
      {
        text: "Resep",
        value: "resep",
        align: "center",
        width: "10%"
      },
      {
        text: "Order",
        value: "order",
        align: "center",
        width: "10%"
      },
      {
        text: "SuKet",
        value: "suket",
        align: "left",
        width: "10%"
      }
    );

    if (this.sess_login.unit_group_id == "27") {
      headers.push({
        text: "Rencana",
        value: "plan",
        align: "left",
        width: "10%"
      });
    }

    if (this.sess_login.unit_id == "01") {
      headers.push(
        {
          text: "Asesmen Gadar",
          value: "asesmen_gadar",
          align: "center",
          width: "auto"
        }
        // {
        //   text: "",
        //   value: "action",
        //   align: "center",
        //   width: "auto"
        // }
      );
    }

    headers.push(
      {
        text: "SEP",
        value: "no_sep",
        align: "left",
        width: "10%"
      },
      {
        text: "Kasir",
        value: "dout",
        align: "left",
        width: "10%"
      },
      { text: "", value: "action", align: "left", width: "auto" }
    );

    return headers;
  }

  get listPasien() {
    const list = storeListPasienRalan.list
      .filter(
        item =>
          item.nama.toLowerCase().includes(this.searchRm) ||
          item.rm.includes(this.searchRm)
      )
      .map(it => {
        it.resep_delivered = it.resep_detail.filter(rsp => rsp.status > 0);
        it.resep_undelivered = it.resep_detail.filter(rsp => rsp.status == 0);
        it.note = this.listPasienNote.filter(note => it.rm == note.rm);
        it.warning = this.renderPasienWarningText(it);
        it.warn_indicator = this.getWarnIndicator(it);

        return it;
      });

    if (this.sortListByPanggilan) {
      list.sort((a, b) => {
        let cFt = 0,
          cQ = 0,
          cC = 0,
          cNo = 0,
          cR = 0;

        if (a.q_type === "f" && b.q_type !== "f") {
          cFt += -1;
        } else if (b.q_type === "f" && a.q_type !== "f") {
          cFt += 1;
        }

        if (["", "f"].includes(a.q_type) && !["", "f"].includes(b.q_type)) {
          cNo += -1;
        } else if (
          ["", "f"].includes(b.q_type) &&
          !["", "f"].includes(a.q_type)
        ) {
          cNo += 1;
        }

        cQ += parseInt(a.queue) > parseInt(b.queue) ? 1 : -1;

        if (a.qdr_call?.present && !b.qdr_call?.present) {
          cC += 1;
        } else if (b.qdr_call?.present && !a.qdr_call?.present) {
          cC += -1;
        }

        if (a.soap_perawat && !b.soap_perawat) {
          cR += -1;
        } else if (b.soap_perawat && !a.soap_perawat) {
          cR += 1;
        }

        return cC || cNo || cFt || cR || cQ;
      });
    }

    return list;
  }

  get showPanggilan() {
    return (
      this.isUserMedis &&
      this.stateuser.unit_id !== "01" &&
      this.canCallPasienManual
    );
  }

  // get data ttg dokter dari cdoc_id dan bpjs_id user yg signed in
  // sebagai dokter
  get activeDokter() {
    return this.stateuser.profesi == "Dokter" ||
      this.stateuser.profesi == "Psikolog"
      ? storeDokter.list.find(item => this.stateuser.id == item.id)
      : null;
  }

  get isUserMedis() {
    return (
      this.stateuser.profesi == "Dokter" || this.stateuser.profesi == "Psikolog"
    );
  }

  get isDokterKaryawan() {
    return (
      this.isUserMedis &&
      !!this.stateuser.map_cdoc &&
      !this.stateuser.is_residen_internship
    );
  }

  dokterPemanggil(item) {
    return this.isDokterKaryawan
      ? this.stateuser.map_cdoc
      : item?.dokter?.c_doc_id;
  }

  get isShowCallAntrianPanel() {
    return (
      (this.isUserMedis || [404, 942, 718].includes(this.stateuser.id)) &&
      this.isUseAutoCallAntrian
    );
  }

  get canCallPasienManual() {
    return userModule.preference?.callAntrianKlinik !== "auto";
  }

  get isUseAutoCallAntrian() {
    return ["27", "2L", "12", "2J", "08", "2F", "17"].includes(
      this.unitIdActive
    );
  }

  get isUseAntrianFasttrack() {
    return ["27", "2L", "17"].includes(this.unitIdActive);
  }

  get listDokter() {
    const dokterKunjungan =
      storeListPasienRalan.dokter ??
      this.listPasien.map(({ dokter }) => ({
        id: dokter.id,
        nama: dokter.c_doc_name,
        c_doc_id: dokter.c_doc_id
      }));
    const gabungan = [...storeDokter.listOnKlinik, ...dokterKunjungan];

    return [
      {
        id: 0,
        nama: "Semua",
        c_doc_id: "0"
      },
      ...gabungan.filter(
        (dokter, idx) =>
          gabungan.findIndex(it => it.c_doc_id == dokter.c_doc_id) === idx
      )
    ];
  }

  get listDokterAll() {
    return storeDokter.listAll;
  }

  get stateuser() {
    return userModule.user;
  }

  get unitIdActive() {
    return userModule.user.unit_id;
  }

  get inputPeriksaActiveRow() {
    return storeListPasienRalan.inputPeriksaActiveRow;
  }

  get showRegisterHF() {
    return userModule.user.unit_group_id == "27";
  }

  get isIgdUnit(): boolean {
    return this.unitIdActive === "01";
  }

  get statusFilterItems(): Array<any> {
    return this.isIgdUnit
      ? IGD_STATUS_FILTER_OPTIONS
      : (this.itemsStatus as Array<any>) || [];
  }

  get statusFilterLabel(): string {
    return this.isIgdUnit ? "Status IGD" : "Status Periksa";
  }

  get defaultStatusFilter(): string {
    return this.isIgdUnit ? IGD_DEFAULT_STATUS_FILTER : IGD_STATUS_FILTER_ALL;
  }

  get showFilterNarrowHint(): boolean {
    return this.isIgdUnit && String(this.sts) !== IGD_STATUS_FILTER_ALL;
  }

  get activeStatusText(): string {
    const found = this.statusFilterItems.find(
      it => String(it.value) === String(this.sts)
    );
    return found ? found.text : "";
  }

  get savedIgdStatusFilter(): string | null {
    const saved = userModule.preference?.daftarPasienIgd?.statusFilter;

    return isIgdStatusFilterValue(saved) ? String(saved) : null;
  }

  resolveInitialStatus(): string {
    if (!this.isIgdUnit) return IGD_STATUS_FILTER_ALL;

    const sticky = storeListPasienRalan.paramStatus;
    const stickyUnit = storeListPasienRalan.paramStatusUnitId;

    if (
      sticky !== null &&
      sticky !== undefined &&
      stickyUnit === this.unitIdActive &&
      isIgdStatusFilterValue(sticky)
    ) {
      return String(sticky);
    }

    return this.savedIgdStatusFilter ?? this.defaultStatusFilter;
  }

  saveIgdStatusFilter(value: string) {
    if (!this.isIgdUnit || !isIgdStatusFilterValue(value)) return;

    userModule
      .savePreference({ daftarPasienIgd: { statusFilter: String(value) } })
      .catch(() => undefined);
  }

  get canFilterByDokter() {
    return (
      // (this.sess_login.profesi != "Dokter" &&
      //   this.sess_login.profesi != "Psikolog") ||
      !this.isUserMedis ||
      this.sess_login.unit_group_id == "11" ||
      this.sess_login.unit_group_id == "01" ||
      !this.stateuser.map_cdoc ||
      this.showAllPasien
    );
  }

  get showPasienByDokterOnMounted() {
    return !isDaftarPasienTanpaFilterDokter(this.sess_login.unit_id);
  }

  get showAllPasien() {
    return !this.showPasienByDokterOnMounted;
  }

  beforeDestroy() {
    this.$root.$off("reload-ranap-global", this.getListPasien);
  }

  async mounted() {
    this.$root.$on("reload-ranap-global", this.getListPasien);

    // subscribe ke websocket
    if (this.stateuser.profesi !== "Dokter") {
      pusher.subscribe(`pemeriksaan.unit.${this.sess_login["unit_id"]}`);
      pusher.bind("resume-ralan-created", () => {
        this.getListPasien();
      });
      // pusher.bind("jurnal-ralan-updated", () => {
      //   this.getListPasien();
      // });
    }

    // Notifikasi "selesai administrasi" untuk halaman Daftar Pasien IGD.
    // Dipasang untuk semua profesi (perawat & dokter IGD perlu sama-sama tahu).
    if (this.sess_login["unit_id"] === "01") {
      pusher.subscribe(`pemeriksaan.unit.01`);
      pusher.bind("igd-administrasi-selesai", (data: any) => {
        if (!data) return;
        const reg = String(data.registerId ?? "");
        // dedupe per session: skip jika register sama sudah dinotifikasi <60s lalu
        const now = Date.now();
        const last = this.igdAdmNotifiedAt[reg] ?? 0;
        if (now - last < 60_000) return;
        this.igdAdmNotifiedAt = { ...this.igdAdmNotifiedAt, [reg]: now };

        const rm = data.rm
          ? `${String(data.rm).substr(2, 2)}-${String(data.rm).substr(
              4,
              2
            )}-${String(data.rm).substr(6, 2)}`
          : "-";
        const nama = data.namaPasien || "Pasien";
        appModule.NoticeDelay(
          `Administrasi selesai: ${nama} (RM ${rm}) siap pulang/pindah`
        );
        this.getListPasien();
      });
    }

    storeListPasienRalan.SET_PARAM_TGL(this.date);
    storeListPasienRalan.SET_PARAM_UNIT(this.unitIdActive);

    if (this.isIgdUnit) {
      await getUserPreferenceData().catch(() => undefined);
    }

    // Samakan nilai select (this.sts) dengan param di store supaya refetch lewat
    // getListWithoutParam()/getListByDokter() dari komponen lain tidak memakai
    // filter yang berbeda dari yang terlihat di layar.
    this.sts = this.resolveInitialStatus();
    storeListPasienRalan.SET_PARAM_STATUS(this.sts);
    storeListPasienRalan.SET_PARAM_STATUS_UNIT(this.unitIdActive);

    // storeListPasienRalan.clearList();

    if (storeListPasienRalan.paramDokterId) {
      this.selectDokter = storeListPasienRalan.paramDokterId;
    } else {
      this.selectDokter =
        userModule.user.map_cdoc && this.showPasienByDokterOnMounted
          ? userModule.user.map_cdoc
          : "0";
    }

    await this.getListPasien();

    this.isFastTrackQueue = storeListPasienRalan.qMode === "fastrack";
    this.sortListByPanggilan = storeListPasienRalan.qSort;

    if (storeListPasienRalan.nowCalling) {
      const nc = storeListPasienRalan.nowCalling;
      this.pxCalled = {
        rm: nc.pasienRm,
        register_id: nc.registerId,
        queue: nc.qNum
      };
    }

    this.unitSwitchActiveId = this.poli?.unit_id;
  }

  canViewRiwayatICare(item) {
    // return sep && this.stateuser.isMedis;
    return item.no_sep && item.dokter?.id;
  }

  cekHasSkriningBatuk(skrining) {
    const batuk = skrining.filter(
      item => item.category == "batuk" && item.content?.value == "1"
    );

    if (batuk.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  async callPasien(rm, registerId, unitId, dokterId, qNext = "") {
    if (!dokterId || dokterId == "0") {
      appModule.sendErrorAlert(
        `Tidak dapat memanggil bila ID Dokter belum dipilih!`
      );
      return false;
    }

    try {
      this.rmCalled = rm;
      this.disableCallBtn = true;

      // simpan checkpoint
      await PasienNewSvc.callToDokter(registerId, rm, unitId, dokterId);

      const params = {
        tanggal: this.date,
        pasien_rm: rm,
        register_id: registerId,
        unit_id: unitId,
        dokter_id: dokterId,
        next: qNext ? qNext : "--"
      };

      // suara panggilan
      const callSound = await PanggilanPoliSvc.call(params);

      if (!callSound.data?.status) {
        throw new Error(callSound.data.message);
      }
    } catch (err) {
      if (!err.response) {
        appModule.sendErrorAlert(`ERR: Display Antrian => ${err.message}`);
      }
    } finally {
      this.rmCalled = null;
      this.disableCallBtn = false;
    }
  }

  togglePasienDatang(rm) {
    this.pasienSetStatusVisit = rm;

    const pasien = this.listPasien.find(item => item.rm == rm);

    const svc =
      pasien.status_visit === "datang"
        ? VisitPasienSvc.setPasienUnconfirmed(
            this.date,
            pasien.register_id,
            pasien.unit.id
          )
        : VisitPasienSvc.setPasienArived(
            this.date,
            pasien.register_id,
            pasien.unit.id
          );

    svc
      .then(() => {
        this.getListPasien();
      })
      .finally(() => {
        this.pasienSetStatusVisit = null;
      });
  }

  togglePasienBatalDatang(items) {
    let conf = true;

    if (items.status_visit !== "batal") {
      conf = confirm(`Anda yakin membatalkan kunjungan pasien ini?`);
    }

    if (conf) {
      const isAnySoapUnit = items.soap.filter(
        item => item.unit_id == this.stateuser.unit_id
      );

      if (isAnySoapUnit.length) {
        appModule.sendErrorAlert(
          "Pasien tidak dapat dibatalkan status kunjungannya bila masih ada catatan/order medis yang telah dibuat. Mohon periksa lagi isian catatan medis/perawat yang telah dibuat sebelum membatalkan kunjungan."
        );
        return false;
      }

      const pasien = this.listPasien.find(item => item.rm == items.rm);

      const svc =
        pasien.status_visit === "batal"
          ? VisitPasienSvc.setPasienUnconfirmed(
              this.date,
              pasien.register_id,
              pasien.unit.id
            )
          : VisitPasienSvc.setPasienNotArived(
              this.date,
              pasien.register_id,
              pasien.unit.id
            );

      svc.then(() => {
        this.getListPasien();
      });
    }
  }

  setDate(val: string) {
    this.date = val;

    storeListPasienRalan.SET_PARAM_TGL(val);

    this.getListPasien();
  }

  changeDokter(item) {
    if (
      ["01"].includes(this.stateuser.unit_id) ||
      this.date !== moment().format("YYYY-MM-DD")
    ) {
      this.modalChangeDokterOpen = true;
      this.dtDokter = item.dokter;
      this.dtReg = {
        register: item.register_id,
        tgl: this.date
      };
    } else {
      appModule.sendErrorAlert(
        "Untuk penggantian dokter dapat menghubungi Pendaftaran"
      );
    }
  }

  showError(item) {
    this.alertOpen = true;
    this.err = {
      errorMsg: item,
      errorIcon: "mdi-alert-circle-outline"
    };
  }

  setStatus(value) {
    this.sts = value;

    storeListPasienRalan.SET_PARAM_STATUS(value);
    storeListPasienRalan.SET_PARAM_STATUS_UNIT(this.unitIdActive);

    this.saveIgdStatusFilter(value);

    this.getListPasien();
  }

  newValDokter() {
    this.getListPasien();
  }

  setDokter(value) {
    this.selectDokter = value;

    storeListPasienRalan.SET_PARAM_DOKTER(value);

    this.getListPasien();
  }

  addPemeriksaan(rm, reg, page, tgl = this.date) {
    // this.page=0
    console.log("reg ", reg);

    this.data = {
      register: reg,
      rm: rm,
      page: page,
      tgl: tgl
    };

    // return this.data;

    this.$emit("addSOAP", this.data);
  }

  parseUrlPemeriksaan(item) {
    const link = this.$router.resolve({
      name: `pemeriksaan`,
      params: {
        register: item.register_id,
        rm: item.rm
      },
      query: {
        key: userModule.token,
        user: JSON.stringify(userModule.user),
        ...actingUnitQueryForListRow(item)
      }
    });

    return link.href;
  }

  async openPasienInNewTab(item) {
    const url = window.location.origin + this.parseUrlPemeriksaan(item);

    if (item.status_visit !== "batal") {
      // kalo IGD gak usah harus checklist
      if (this.stateuser.unit_id === "01") {
        window.open(url, "_blank");
      } else {
        let q = true;

        if (!item.status_visit) {
          q = confirm("Pasien ini belum hadir, konfirmasi kehadiran sekarang?");

          if (q) {
            await this.togglePasienDatang(item.rm);

            q = confirm("Input pemeriksaan pasien ini?");
          }
        }

        if (q) {
          window.open(url, "_blank");
        }
      }
    } else if (item.status_visit === "batal") {
      const q = confirm(
        "Peringatan: Pasien ini BATAL PERIKSA, Anda tidak dapat input pemeriksaan lebih lanjut. Lanjutkan ke halaman pemeriksaan?"
      );

      if (q) {
        window.open(url, "_blank");
      }
    }
  }

  async handleInputPemeriksaanClickEvent(item, page) {
    // Clear any existing debounce timer
    if (this.pemeriksaanDebounceTimer) {
      clearTimeout(this.pemeriksaanDebounceTimer);
    }

    // Set new debounce timer for 2 seconds
    this.pemeriksaanDebounceTimer = setTimeout(() => {
      this.executeHandleInputPemeriksaan(item, page);
    }, 600);
  }

  async executeHandleInputPemeriksaan(item, page) {
    if (item.status_visit === null) {
      // kalo IGD gak usah harus checklist, langsung checklist datang begitu klik pemeriksaan
      if (this.stateuser.unit_id === "01") {
        // await this.togglePasienDatang(item.rm);

        await this.addPemeriksaan(item.rm, item.register_id, page);
      } else {
        const q = confirm(
          "Pasien ini belum hadir, konfirmasi kehadiran sekarang?"
        );

        if (q) {
          await this.togglePasienDatang(item.rm);

          const qInput = confirm("Input pemeriksaan pasien ini?");

          if (qInput) {
            await this.addPemeriksaan(item.rm, item.register_id, page);
          }
        }
      }
    } else if (item.status_visit === "batal") {
      const q = confirm(
        "Peringatan: Pasien ini BATAL PERIKSA, Anda tidak dapat input pemeriksaan lebih lanjut. Lanjutkan ke halaman pemeriksaan?"
      );

      if (q) {
        await this.addPemeriksaan(item.rm, item.register_id, page);
      }
    } else {
      if (
        item.tipe_pasien == "konsul" &&
        item.surat_konsul_masuk &&
        !item.surat_konsul_masuk.jawaban
      ) {
        await this.jawabKonsul(
          item.surat_konsul_masuk.accepted_register_id,
          item.rm
        );
      } else {
        await this.addPemeriksaan(item.rm, item.register_id, page);
      }
    }
    storeListPasienRalan.inputPeriksaActiveRow;
  }

  @Watch("inputPeriksaActiveRow")
  changeInputPeriksaActiveRow(val) {
    if (val) {
      this.handleInputPemeriksaanClickEvent(
        storeListPasienRalan.activeRow,
        "tab-soap"
      );
    }

    storeListPasienRalan.SET_INPUT_PERIKSA_ACTIVE_ROW(false); // ngakali kalo ada yg klik tombol pemeriksaan > 1 kali; biar true tetap terbaca perubahannya di watch
  }

  // @Emit("dataCM")
  selectRowPasien(item, row = null) {
    // row.select(true);

    this.$emit("dataCM", { item: item });

    storeListPasienRalan.setActiveRowFromPasienRm(item.rm);
  }

  async getListPasien() {
    storeListPasienRalan
      .getList({
        tgl: this.date,
        unitId: this.unitIdActive,
        dokterId: this.selectDokter,
        status: this.sts
      })
      .finally(() => {
        appModule.setLoading(false);
      });
  }

  refreshList() {
    // this.sts = "-1";
    // this.searchRm = "";
    // this.selectDokter = 0;

    this.getListPasien();
  }

  lastItemSoapJantung(
    items
  ): {
    subjective: string;
    objective: string;
    assesment: string;
    plan: string;
  } {
    return last(
      items.filter(soap => {
        return soap.unit_id == "27" || soap.unit_id == "2L";
      })
    );
  }

  cancelTerimaKonsul(id) {
    const conf = confirm("Membatalkan penerimaan pasien rujukan internal ini?");

    if (conf) {
      DataKonsul.cancelTerimaKonsul(id)
        .then(() => {
          // location.reload();
          // this.getListPasien();
        })
        .finally(() => {
          this.getListPasien();
          storeKonsul.getListKonsulWithoutParam();
        });
    }
  }

  handleRowHover(item) {
    this.highlightedRow = item.rm;
  }

  handleRowLeave() {
    this.highlightedRow = null;
  }

  // async jawabKonsul(id) {
  //   const dtK = await DataPasien.getDetailKonsulan(id).then(dtK => {
  //     console.log("dt konsul", dtK);

  //     // const register = dtK["data"].register;
  //     // const rm = dtK["data"].pasien.rm;
  //     // const data = [register, "tab-jwbkonsul", rm];

  //     const register = "23090121";
  //     const rm = dtK["data"].pasien.rm;
  //     const data = [register, "tab-jwbkonsul", rm];

  //     this.$emit("jwbKonsul", data);
  //   });
  // }

  async jawabKonsul(register, rm) {
    const data = [register, "tab-jwbkonsul", rm];

    this.$emit("jwbKonsul", data);
  }

  startLayanan() {
    PanggilanPoliSvc.startDisplay({
      tanggal: this.date,
      unit_id: this.unitIdActive,
      dokter_id: this.activeDokter?.c_doc_id
    });
  }

  detailRiwayat(rm) {
    this.$router.push({
      name: `detail-pasien`,
      params: {
        rm: rm
      }
    });
  }

  inputSearchRm() {
    // untuk ngantisipasi searchRm yg jadi null ketika di-clear
    this.searchRm = this.searchRm || "";
  }

  pxCalled = null;

  queueCalling = false;
  isFastTrackQueue = false;

  // get isFastTrackQueue() {
  //   return storeListPasienRalan.qMode === "fastrack";
  // }

  changeQMode(val) {
    storeListPasienRalan.setQMode(val ? "fastrack" : "regular");
  }

  changeQSort(val) {
    storeListPasienRalan.setQSort(val);
  }

  get curQueue() {
    return this.pxCalled?.queue;
  }

  get canShowAntrianContextMenu() {
    return (
      this.isUseAutoCallAntrian &&
      ![".", "_"].includes(this.activePasienContext?.q_type)
    );
  }

  get isPasienCtxRegular() {
    return this.activePasienContext?.q_type == "";
  }

  get isPasienCalledPresent() {
    return this.activePasienContext?.qdr_call?.present;
  }

  @Watch("pxCalled")
  changePxCalled(val) {
    if (!val) {
      this.rmCalled = null;
    } else {
      this.rmCalled = val.rm;

      setTimeout(() => {
        this.rmCalled = null;
      }, 2000);
    }
  }

  // versi API laravel
  // async callNextQueue() {
  //   // if (!this.pxCalled) {
  //   //   this.pxCalled = this.listPasien[0];
  //   // } else {
  //   //   const idx = this.listPasien.findIndex(item => item == this.pxCalled);

  //   //   this.pxCalled = this.listPasien[idx + 1] ?? this.listPasien[0];
  //   // }
  //   this.queueCalling = true;

  //   PanggilanPoliSvc.callNext(
  //     this.date,
  //     this.unitIdActive,
  //     this.stateuser.map_cdoc
  //   )
  //     .then(resp => {
  //       if (resp.status) {
  //         const { pasien_rm, qu, register_id } = resp.data.current;

  //         this.pxCalled = this.listPasien.find(
  //           item =>
  //             item.rm == pasien_rm &&
  //             item.queue == qu &&
  //             item.register_id == register_id
  //         );
  //       } else {
  //         this.pxCalled = null;
  //       }

  //       this.selectRowPasien(this.pxCalled);
  //     })
  //     .finally(() => {
  //       this.queueCalling = false;
  //     });
  // }

  // versi API p.yusuf
  async callNextQueue() {
    if (!this.selectDokter || this.selectDokter == "0") {
      appModule.sendErrorAlert(
        "Untuk melakukan panggilan ID dokter harus ditentukan!"
      );
      return false;
    }

    this.queueCalling = true;

    PanggilanPoliSvc.callNextAlternative(
      this.date,
      this.unitIdActive,
      this.selectDokter,
      this.isFastTrackQueue ? "f" : null
    )
      .then(resp => {
        if (resp.status && resp.nq > 0) {
          this.pxCalled = this.listPasien.find(item => item.queue == resp.nq);
          // untuk set penanda centang panggilan
          this.pxCalled.qdr_call = {
            q_type: resp?.q_type ?? "",
            present: 0,
            qn: 1,
            t: moment().format("YYYY-MM-DD HH:mm:ss")
          };

          this.nowCalling = resp;

          storeListPasienRalan.setNowCalling({
            pasienRm: this.pxCalled.rm,
            registerId: this.pxCalled.register_id,
            qNum: resp.nq,
            qText: resp.qtext
          });

          this.callPasien(
            this.pxCalled.rm,
            this.pxCalled.register_id,
            this.unitIdActive,
            this.selectDokter,
            resp.next_qt
          );

          this.selectRowPasien(this.pxCalled);
        } else {
          appModule.sendErrorAlert("Tidak ada pasien yang dapat dipanggil...");

          storeListPasienRalan.setNowCalling(null);
          this.pxCalled = null;
        }
      })
      .finally(() => {
        this.queueCalling = false;
      });

    // this.pxCalled = this.listPasien.find(item => item.queue == 1);
    // this.selectRowPasien(this.pxCalled);
    // this.queueCalling = false;

    // this.pxCalled = this.listPasien.find(item => item.queue == this.resp.nq);
    // this.nowCalling = this.resp;
    // this.pxCalled.qdr_call = {
    //   q_type: "",
    //   present: 0,
    //   qn: 1,
    //   t: moment().format("YYYY-MM-DD HH:mm:ss")
    // };

    // this.resp.nq++;

    // this.queueCalling = false;
  }

  resp = {
    nq: 8,
    rm: 603585
  };

  nowCalling = null;

  replayQueue() {
    const called = this.pxCalled;
    this.pxCalled = null;
    this.pxCalled = called;

    this.callPasien(
      called.rm,
      called.register_id,
      this.unitIdActive,
      this.selectDokter,
      this.nowCalling?.next_qt
    );
  }

  setNamaColor(item) {
    return item.q_type == "f" ? "primary" : "black";
  }

  async setPasienFastTrack(date, registerId, unitId) {
    await VisitPasienSvc.setPasienAntrianChannel(
      date,
      registerId,
      unitId,
      "f"
    ).then(resp => {
      if (resp.status == 1) {
        this.refreshList();
      }
    });
  }

  async setPasienAntrianReguler(date, registerId, unitId) {
    await VisitPasienSvc.setPasienAntrianChannel(
      date,
      registerId,
      unitId,
      ""
    ).then(resp => {
      if (resp.status == 1) {
        this.refreshList();
      }
    });
  }

  async setPasienRecall(date, registerId, unitId, drId) {
    console.log("set pasien recall", drId);

    if (drId < "1") {
      appModule.sendErrorAlert("Pilih ID Dokter terlebih dahulu!");

      return false;
    }

    await PanggilanPoliSvc.updatePanggilan(date, unitId, drId, registerId, {
      present: 0
    }).then(resp => {
      if (resp.status == 1) {
        this.refreshList();
      }
    });
  }

  async setPasienTerpanggil(date, registerId, unitId, drId) {
    if (drId < "1") {
      appModule.sendErrorAlert("Pilih ID Dokter terlebih dahulu!");

      return false;
    }

    await PanggilanPoliSvc.updatePanggilan(date, unitId, drId, registerId, {
      present: 1
    }).then(resp => {
      if (resp.status == 1) {
        this.refreshList();
      }
    });
  }

  icareLoading = false;

  async getRiwayatICare(registerId, dokterId) {
    if (this.date < moment().format("YYYY-MM-DD")) {
      alert(
        `Fitur iCare BPJS hanya bisa tampil untuk pasien yang periksa hari ini (${moment().format(
          "YYYY-MM-DD"
        )})`
      );

      return false;
    }

    if (!this.icareLoading) {
      this.icareLoading = true;

      await HistoryPeserta.getICareByReg(registerId, dokterId)
        .then(resp => {
          if (resp.status === 1) {
            // this.showPopupBrowser(resp.data);
            this.showPopupICareDialog(resp.data);
          } else {
            alert(resp.message);
          }
        })
        .finally(() => {
          this.icareLoading = false;
        });
    }
  }

  showPopupBrowser(
    url: string,
    timeout = null,
    opts = {
      width: 800,
      height: 600,
      scroll: true,
      resize: true
    }
  ) {
    const windowName = "popupWindow";
    const windowFeatures = `width=${opts.width},height=${
      opts.height
    },scrollbars=${opts.scroll ? "yes" : "no"},resizable=${
      opts.resize ? "yes" : "no"
    }`;
    let popTimeout = null;
    // let checkLoadInterval = null;
    const popup = window.open(url, windowName, windowFeatures);

    if (!popup) {
      alert(
        "Tampilan yang diingikan tidak bisa tampil. Coba nonaktifkan fitur Ad-Blocker di browser Anda!"
      );

      return false;
    }

    const startPopTimeout = () => {
      popTimeout = setTimeout(() => {
        popup.close();
      }, timeout ?? 60000);
    };

    startPopTimeout();
  }

  showICareDialog = false;
  icareUrl = "";

  showPopupICareDialog(url) {
    this.icareUrl = url;
    this.showICareDialog = true;
  }

  @Watch("showICareDialog")
  changeShowICareDialog(val) {
    if (!val) {
      this.icareUrl = "";
    }
  }

  fetchDokterSoap(soapData: [any]) {
    const d = soapData.map(it => it.dr_id),
      dr = this.listDokterAll.filter(it => d.includes(it.id.toString()));

    return dr;
  }

  listPasienNote = [];

  getListPasienNote() {
    PasienNote.getMultiPasienNote(this.listPasien.map(it => it.rm)).then(
      resp => {
        this.listPasienNote = resp.data;
      }
    );
  }

  get listPasienTag() {
    return this.listPasienTagData;
  }

  listPasienTagData = [];

  getListPasienTag() {
    PasienNew.getMultiPasienTag(this.listPasien.map(it => it.rm)).then(resp => {
      this.listPasienTagData = resp;
    });
  }

  get listStorePasien() {
    return storeListPasienRalan.list;
  }

  @Watch("listStorePasien")
  changeListPasien(val) {
    this.getListPasienNote();
    this.getListPasienTag();
  }

  renderPasienWarningText(item) {
    const isBatuk =
      item.skrining.filter(
        item => item.category == "batuk" && item.content?.value == "1"
      ).length > 0;
    const notes = item.note.map(note => note.note);

    const texts = [
      isBatuk ? "Batuk lebih dari 2 minggu" : null,
      ...notes
    ].filter(it => it);

    return texts.join("<br/>");
  }

  getWarnIndicator(item) {
    const attr = storePasien.pasientTagAttribute;
    return (
      this.listPasienTagData[item.rm]?.map(it => {
        const tag = attr[it.name] || attr.default;
        return tag.activeText;
      }) ?? []
    );
  }

  get isUnitHasSibling() {
    return this.unitSibling.length > 0;
  }

  get unitSibling() {
    // if (
    //   ["03", "2I", "1A", "1B", "1C", "1D", "1E"].includes(
    //     this.stateuser.unit_id
    //   )
    // ) {
    //   return [
    //     {
    //       kode: "03",
    //       nama: "Klinik Gigi",
    //       unit_group_id: "03",
    //       zona: "1"
    //     },
    //     {
    //       kode: "2I",
    //       nama: "Klinik Gigi (Sore)",
    //       unit_group_id: "03",
    //       zona: "1"
    //     },
    //     {
    //       kode: "1A",
    //       nama: "Klinik Gigi Bedah Mulut",
    //       unit_group_id: "03",
    //       zona: "1"
    //     },
    //     {
    //       kode: "1B",
    //       nama: "Klinik Gigi Konservasi",
    //       unit_group_id: "03",
    //       zona: "1"
    //     },
    //     {
    //       kode: "1C",
    //       nama: "Klinik Gigi Orthodonti",
    //       unit_group_id: "03",
    //       zona: "1"
    //     },
    //     {
    //       kode: "1D",
    //       nama: "Klinik Gigi Prosthodonti",
    //       unit_group_id: "03",
    //       zona: "1"
    //     }
    //   ];
    // } else {
    //   return [];
    // }
    const grp = ReferensiUnit.sessGroupUnits;
    if (grp.length > 1) {
      return grp.map(it => {
        return {
          kode: it.id,
          nama: it.nama,
          unit_group_id: it.unitGroup,
          zona: it.zona
        };
      });
    }

    return [];
  }

  @Watch("unitSwitchActiveId")
  changeUnitSwitchActiveId(val, oldVal) {
    const newUnit = this.unitSibling.find(item => item.kode == val);

    if (newUnit && oldVal) {
      userModule.changeSessionUnit({
        kode: newUnit.kode,
        nama: newUnit.nama,
        unit_group_id: newUnit.unit_group_id,
        zona: newUnit.zona
      });

      this.$nextTick(() => {
        this.$emit("switchUnit");
      });
    }
  }
}
